module.exports = __webpack_public_path__ + "static/to-go-ca55a5bac0184f63b6b19ffc324fd732.svg";